import { useAuth } from './AuthContext';
import { adminPreferencesStorage } from '../../infrastructure/storage/AdminPreferencesStorage';

const DEFAULTS = {
  language: 'en-GB',
  timezone: 'UTC',
} as const;

/**
 * Returns the current admin's language and timezone preferences.
 * Fallback chain: auth context (React state) → sessionStorage → defaults.
 */
export function useAdminPreferences(): { language: string; timezone: string } {
  const { admin } = useAuth();

  if (admin) {
    return { language: admin.language, timezone: admin.timezone };
  }

  const language = adminPreferencesStorage.getLanguage();
  const timezone = adminPreferencesStorage.getTimezone();

  if (language && timezone) {
    return { language, timezone };
  }

  return DEFAULTS;
}
